// extracted by mini-css-extract-plugin
module.exports = {"header__wrapper":"r_9","header__text--primary":"r_bb header","header__text--secondary":"r_bc header"};